import Img1 from "../../images/ads (1).png";
import Img2 from "../../images/book formatting (1).png";
import Img3 from "../../images/book formatting (3).png";
import Img4 from "../../images/app design (2).png";
import Img5 from "../../images/ads (2).png";
import Img6 from "../../images/ads (3).png";
import Img7 from "../../images/app icon (1).png";
import Img8 from "../../images/ads (4).png";
import Img9 from "../../images/app icon (2).png";
import Img10 from "../../images/app icon (4).png";
import Img11 from "../../images/app icon (3).png";
import Img12 from "../../images/flyer (1).jpg";
import Img13 from "../../images/app icon (8).png";
import Img14 from "../../images/app icon (6).png";
import Img15 from "../../images/app icon (9).png";
import Img16 from "../../images/app icon (10).png";
import Img17 from "../../images/app icon (11).png";
import Img18 from "../../images/book formatting (2).png";
import Img19 from "../../images/landing page (1).png";
import Img20 from "../../images/landing page (2).png";
import Img21 from "../../images/app design (1).png";
import Img22 from "../../images/app design (3).png";
import Img23 from "../../images/app design (4).png";

const projects = [
  {
    id: 1,
    category: "book formatting",
    img: Img18,
  },
  {
    id: 2,
    category: "landing page",
    img: Img20,
  },
  {
    id: 3,
    category: "app icon",
    img: Img9,
  },
  {
    id: 4,
    category: "add design",
    img: Img1,
  },
  {
    id: 5,
    category: "book formatting",
    img: Img2,
  },
  {
    id: 6,
    category: "app design",
    img: Img4,
  },
  {
    id: 7,
    category: "add design",
    img: Img5,
  },
  {
    id: 8,
    category: "app icon",
    img: Img10,
  },
  {
    id: 9,
    category: "add design",
    img: Img6,
  },
  {
    id: 10,
    category: "app icon",
    img: Img7,
  },
  {
    id: 11,
    category: "book formatting",
    img: Img3,
  },
  {
    id: 12,
    category: "add design",
    img: Img8,
  },
  {
    id: 13,
    category: "app icon",
    img: Img11,
  },

  {
    id: 14,
    category: "app design",
    img: Img21,
  },
  {
    id: 15,
    category: "app icon",
    img: Img15,
  },
  {
    id: 16,
    category: "landing page",
    img: Img19,
  },
  {
    id: 17,
    category: "app icon",
    img: Img13,
  },
  {
    id: 18,
    category: "book formatting",
    img: Img18,
  },
  {
    id: 19,
    category: "app icon",
    img: Img12,
  },
  {
    id: 20,
    category: "app design",
    img: Img23,
  },
  {
    id: 21,
    category: "app icon",
    img: Img14,
  },
  {
    id: 22,
    category: "book formatting",
    img: Img18,
  },
  {
    id: 23,
    category: "app design",
    img: Img22,
  },
  {
    id: 24,
    category: "app icon",
    img: Img16,
  },

  {
    id: 25,
    category: "app icon",
    img: Img17,
  },
];
export default projects;
